import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Link } from 'react-router';

import { Table, TableBody, TableHeader, TableHeaderColumn, TableRow } from 'material-ui/Table';
import TextField from 'material-ui/TextField';
import Pagination from 'components/Libs/Pagination';
import RaisedButton from 'material-ui/RaisedButton';
import Checkbox from 'material-ui/Checkbox';
import Dialog from 'material-ui/Dialog';

import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';

import { getVessels } from 'actions/vessels/vessels';
import api from 'services';
import styles from 'styles';
import VesselRow from './Row';
import VesselImport from './VesselImport';

import { UserPerms } from 'store/configureStore';
import { RadioButton } from 'material-ui';

const getDate = (type) => {
    const date = new Date();
    switch (type) {
    case 'week':
        date.setDate(date.getDate() - 7);
        return date;
    case 'month': 
        date.setMonth(date.getMonth() - 1);
        return date;
    case 'year':
        date.setFullYear(date.getFullYear() - 1);
        return date;
    default:
        return date;
    }
};

const exclusionsAndRestrictions = [
    {
        date: undefined,
        label: '',
    },
    {
        date: getDate('week'),
        label: 'Last Week',
    }, {
        date: getDate('month'),
        label: 'Last Month',
    }, {
        date: getDate('year'),
        label: 'Last Year',
    },
];

class VesselListTable extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            rowsPerPage: [25, 50, 100],
            rows: [],
            numberOfRows: 25,
            page: 1,
            total: undefined,
            notConfirmed: false,
            vesselImportModalOpen: false,
            isNameSuggestion: false,
            modifiedFilter: 'all',
            photosFilter: 'all',
            filterCargoExclusions: null,
            filterTradingRestrictions: null,
        };

        this.handleSearch = this.handleSearch.bind(this);
        this.updateRows = this.updateRows.bind(this);
        this.clearSearch = this.clearSearch.bind(this);
        this.handleNameSuggested = this.handleNameSuggested.bind(this);
        this.handleConfirmed = this.handleConfirmed.bind(this);
        this.handleOpenImportVessels = this.handleOpenImportVessels.bind(this);
        this.handleCloseImportVessels = this.handleCloseImportVessels.bind(this);
        this.handleUpdateImportDialog = this.handleUpdateImportDialog.bind(this);

        this.handleFilters = this.handleFilters.bind(this);

        this.handleExclusions = this.handleExclusions.bind(this);
        this.renderExclusionsAndRestrictions = this.renderExclusionsAndRestrictions.bind(this);
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        const { vessels } = nextProps;

        this.setState({
            total: vessels.total,
            rows: vessels.data,
            page: vessels.page,
            numberOfRows: vessels.limit,
            notConfirmed: vessels.notConfirmed,
            filterCargoExclusions: vessels.filterCargoExclusions,
            filterTradingRestrictions: vessels.filterTradingRestrictions,
            isNameSuggestion: vessels.isNameSuggestion,
            photosFilter: vessels.photosFilter,
        });
    }

    handleNameSuggested() {
        this.setState(
            {
                isNameSuggestion: !this.state.isNameSuggestion,
            },

            () => {
                this.props.getVessels({
                    page: 1,
                    limit: this.state.numberOfRows,
                    notConfirmed: this.state.notConfirmed,
                    isNameSuggestion: this.state.isNameSuggestion,
                    photosFilter: this.state.photosFilter,
                });
            },
        );
    }

    handleConfirmed() {
        this.setState(
            {
                notConfirmed: !this.state.notConfirmed,
            },
            () => {
                this.props.getVessels({
                    page: 1,
                    limit: this.state.numberOfRows,
                    notConfirmed: this.state.notConfirmed,
                    isNameSuggestion: this.state.isNameSuggestion,
                    photosFilter: this.state.photosFilter,
                });
            },
        );
    }

    clearSearch(e, value) {
        if (value.length === 0) {
            this.props.getVessels({
                page: this.state.page,
                limit: this.state.numberOfRows,
            });
        }
    }

    async handleSearch() {
        if (!this.refs.search.input.value.length) {
            return;
        }

        await api
            .findVessel(this.refs.search.input.value, !this.state.notConfirmed, this.state.isNameSuggestion)
            .then((response) => {
                if (response.status === 200) {
                    this.setState({
                        rows: response.data.data,
                        page: 1,
                        limit: 25,
                    });
                }
            });
    }

    updateRows(state) {
        this.props.getVessels({
            page: state.page,
            limit: state.numberOfRows,
            notConfirmed: this.state.notConfirmed,
            isNameSuggestion: this.state.isNameSuggestion,
            photosFilter: this.state.photosFilter,
        });
    }

    handleOpenImportVessels() {
        this.setState({ vesselImportModalOpen: true });
    }

    handleCloseImportVessels() {
        this.setState({ vesselImportModalOpen: false });
    }

    handleUpdateImportDialog() {
        this.refs.importDialog.forceUpdate();
    }

    handleFilters(field, value) {
        this.setState(
            {
                [field]: value,
            },
            () => {
                this.props.getVessels({
                    page: 1,
                    limit: this.state.numberOfRows,
                    isNameSuggestion: this.state.isNameSuggestion,
                    notConfirmed: this.state.notConfirmed,
                    [field]: value,
                });
            },
        );
    }

    handleExclusions(period, property) {
        if (!property) return;
        this.setState(
            {
                [property]: period ? new Date(period).toISOString() : undefined,
            },
            () => {
                this.props.getVessels({
                    ...this.state,
                });
            },
        );
    }

    renderExclusionsAndRestrictions() {
        return exclusionsAndRestrictions.map(excl => (
            <MenuItem value={excl.date ? excl.date.toISOString() : undefined} primaryText={excl.label} />
        ));
    }

    render() {
        const {
            total,
            rowsPerPage,
            page,
            numberOfRows,
            search,
            rows,
            isNameSuggestion,
            notConfirmed,
            filterCargoExclusions,
            filterTradingRestrictions,
            modifiedFilter,
            photosFilter,
        } = this.state;
        const { vessels } = this.props;

        const disableAdminFunctions = !UserPerms.isAdmin();

        const pagination = (
            <div
                className="center-xs middle-xs"
                style={{ display: 'flex' }}
            >
                <Pagination
                    total={total}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    numberOfRows={numberOfRows}
                    updateRows={this.updateRows}
                />
            </div>
        );
        return (
            <div>
                <Dialog
                    ref="importDialog"
                    title="Import/Update vessels from LOTUS"
                    modal={false}
                    open={this.state.vesselImportModalOpen}
                    onRequestClose={this.handleCloseImportVessels}
                    autoScrollBodyContent
                    style={{ height: '60vh', width: '90vw' }}
                >
                    <VesselImport onUpdate={this.handleUpdateImportDialog} />
                </Dialog>
                <div className='table-header'>
                    <div className='item'>
                        <div
                            className="center-xs middle-xs"
                            style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'flex-start' }}
                        >
                            <TextField
                                defaultValue={search}
                                floatingLabelText="Search by imonumber or name"
                                ref="search"
                                style={{ minWidth: '100px' }}
                                onChange={this.clearSearch}
                                onKeyPress={(event) => {
                                    if (event.charCode === 13) {
                                        event.preventDefault();
                                        this.handleSearch();
                                    }
                                }}
                            />

                            <RaisedButton
                                label="Search"
                                style={styles.RaisedButton}
                                primary
                                onClick={this.handleSearch}
                            />
                            <Checkbox
                                label="Not confirmed"
                                checked={notConfirmed}
                                onCheck={this.handleConfirmed}
                                style={{
                                    display: 'inline-block',
                                    margin: '0 0 0 10px',
                                    width: '160px',
                                    textAlign: 'start',
                                }}
                                labelStyle={{ fontSize: '13px' }}
                            />
                            <Checkbox
                                label="Rename suggestion"
                                checked={isNameSuggestion}
                                onCheck={this.handleNameSuggested}
                                style={{
                                    display: 'inline-block',
                                    margin: '0 0 0 10px',
                                    width: '160px',
                                    textAlign: 'start',
                                }}
                                labelStyle={{ fontSize: '13px', width: '100%' }}
                            />
                        </div>

                    </div>
                    <div className='item'>
                        <div
                            className="center-xs middle-xs"
                            style={{ display: 'flex' }}
                        >
                            <span>VESSELS: {vessels.total}</span>
                        </div>
                        {pagination}
                    </div>
                </div>
                <div className='table-header'>
                    <div className='item' style={{ display: 'flex' }}>
                        <RadioButton
                            label="All"
                            checked={modifiedFilter === 'all'}
                            onCheck={() => this.handleFilters('modifiedFilter', 'all')}
                            style={{
                                display: 'inline-block',
                                width: '60px',
                                textAlign: 'start',
                            }}
                            labelStyle={{ fontSize: '13px' }}
                        />
                        <RadioButton
                            label="Modified"
                            checked={modifiedFilter === 'modified'}
                            onCheck={() => this.handleFilters('modifiedFilter', 'modified')}
                            style={{
                                display: 'inline-block',
                                width: '130px',
                                textAlign: 'start',
                            }}
                            labelStyle={{ fontSize: '13px' }}
                        />
                        <RadioButton
                            label="Not modified"
                            checked={modifiedFilter === 'notModified'}
                            onCheck={() => this.handleFilters('modifiedFilter', 'notModified')}
                            style={{
                                display: 'inline-block',
                                width: '160px',
                                textAlign: 'start',
                            }}
                            labelStyle={{ fontSize: '13px' }}
                        />
                        <div style={{ position: 'relative' }}>
                            <span style={{ fontSize: '13px', position: 'absolute' }}>Cargo exclusions</span>
                            <SelectField 
                                floatingLabelText="Last updated"
                                floatingLabelStyle={{ left: '0', fontSize: '13px' }}
                                value={filterCargoExclusions}
                                onChange={(ev, index, val) => this.handleExclusions(val, 'filterCargoExclusions')}
                                style={{ marginTop: '-10px', width: '150px', textAlign: 'left' }}
                            >
                                {this.renderExclusionsAndRestrictions()}
                            </SelectField>
                        </div>
                        <div style={{ position: 'relative' }}>
                            <span style={{ fontSize: '13px', marginLeft: '10px', position: 'absolute' }}>Trading restrictions</span>
                            <SelectField 
                                floatingLabelText="Last updated"
                                floatingLabelStyle={{ left: '0', fontSize: '13px' }}
                                value={filterTradingRestrictions}
                                onChange={(ev, index, val) => this.handleExclusions(val, 'filterTradingRestrictions')}
                                style={{
                                    marginTop: '-10px', marginLeft: '10px', width: '150px', textAlign: 'left', 
                                }}
                            >
                                {this.renderExclusionsAndRestrictions()}
                            </SelectField>
                        </div>
                    </div>
                    <div className='item'>
                        <div
                            className="center-xs middle-xs"
                            style={{ display: 'flex' }}
                        >
                            <RaisedButton
                                label="ADD NEW VESSEL"
                                style={styles.RaisedButton}
                                primary
                                containerElement={<Link to="/vessels/add" />}
                            />

                            <RaisedButton
                                label="IMPORT/UPDATE VESSELS"
                                style={styles.importVesselsBtn}
                                disabled={disableAdminFunctions}
                                onClick={this.handleOpenImportVessels}
                                secondary
                            />
                        </div>
                    </div>
                </div>
                <div className='table-header'>
                    <div className='item'>
                        <RadioButton
                            label="All"
                            checked={photosFilter === 'all'}
                            onCheck={() => this.handleFilters('photosFilter', 'all')}
                            style={{
                                display: 'inline-block',
                                width: '60px',
                                textAlign: 'start',
                            }}
                            labelStyle={{ fontSize: '13px' }}
                        />
                        <RadioButton
                            label="With photos"
                            checked={photosFilter === 'withPhotos'}
                            onCheck={() => this.handleFilters('photosFilter', 'withPhotos')}
                            style={{
                                display: 'inline-block',
                                width: '130px',
                                textAlign: 'start',
                            }}
                            labelStyle={{ fontSize: '13px' }}
                        />
                        <RadioButton
                            label="Without photos"
                            checked={photosFilter === 'withoutPhotos'}
                            onCheck={() => this.handleFilters('photosFilter', 'withoutPhotos')}
                            style={{
                                display: 'inline-block',
                                width: '160px',
                                textAlign: 'start',
                            }}
                            labelStyle={{ fontSize: '13px' }}
                        />
                    </div>
                </div>
                <div className="table-body">
                    <Table selectable={false}>
                        <TableHeader
                            displaySelectAll={false}
                            adjustForCheckbox={false}
                        >
                            <TableRow>
                                <TableHeaderColumn
                                    style={styles.tableRowColumnSmallCSS}
                                >
                                    imoNumber
                                </TableHeaderColumn>
                                <TableHeaderColumn
                                    style={styles.tableRowColumnSmallCSS}
                                >
                                    name
                                </TableHeaderColumn>
                                <TableHeaderColumn
                                    style={styles.tableRowColumnSmallCSS}
                                >
                                    Year
                                </TableHeaderColumn>
                                <TableHeaderColumn
                                    style={styles.tableHeaderColumnCSS}
                                >
                                    Type By Purpose
                                </TableHeaderColumn>
                                <TableHeaderColumn
                                    style={styles.tableHeaderColumnCSS}
                                >
                                    Class
                                </TableHeaderColumn>
                                <TableHeaderColumn
                                    style={styles.tableHeaderColumnCSS}
                                >
                                    Gears
                                </TableHeaderColumn>
                                <TableHeaderColumn
                                    style={styles.tableRowColumnSmallCSS}
                                >
                                    Capacity (G/B)
                                </TableHeaderColumn>
                                <TableHeaderColumn
                                    style={styles.tableRowColumnSmallCSS}
                                >
                                    DWT
                                </TableHeaderColumn>
                                <TableHeaderColumn
                                    style={styles.tableRowColumnModified}
                                >
                                    Modified
                                </TableHeaderColumn>
                                <TableHeaderColumn
                                    style={styles.tableRowColumnSmallCSS}
                                >
                                    Actions
                                </TableHeaderColumn>
                            </TableRow>
                        </TableHeader>

                        <TableBody displayRowCheckbox={false}>
                            {rows.map(item => (
                                <VesselRow key={item._id} item={item} />
                            ))}
                        </TableBody>
                    </Table>
                </div>
            </div>
        );
    }
}

export default connect(
    ({ vessels, user }) => ({
        vessels,
        userId: user._id,
    }),
    dispatch => bindActionCreators(
        {
            getVessels,
        },
        dispatch,
    ),
)(VesselListTable);



// WEBPACK FOOTER //
// ./app/components/Vessels/List/Table.jsx